import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.6.5_@types+node@18.0.0_rollup@3.27.0_sass@1.64.1/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}